import { Platform, StyleSheet, Dimensions } from 'react-native';
import { widthInPercentage } from '../../../utils/appUtils';

const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;

export default StyleSheet.create({
  container: {
    width: '100%',
    flex: 1,
    alignItems: 'center',
    backgroundColor: 'white'
  },
  componentView: {
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 100
  },
  btnstyle: {
    position: Platform.OS === 'web' ? 'fixed' : 'absolute',
    bottom: 0,
    right: 0,
    left: 0,
    elevation: 15,
    backgroundColor: '#fff'
  },

  // buton color example
  buttonColor: {
    color: 'black',
    fontSize: 24,
    textAlign: 'center'
  },
  buttontext: {
    color: 'black' //common for laptop
  },
  buttontext_XXXHDPI: {
    color: 'white'
  },
  buttontext_XXHDPI: {
    color: 'black'
  },
  buttontext_XHDPI: {
    color: 'black'
  },
  buttontext_HDPI: {
    color: 'black'
  },
  buttontext_MDPI: {
    color: 'black'
  },
  buttontext_LDPI: {
    color: 'black'
  },

  // back ground container
  backgroundContainer: {
    borderWidth: 1
  },

  // ..........
  topSPaceForHeading: {
    justifyContent: 'center',
    // textAlign: 'center',
    fontSize: 30,
    fontWeight: '900',
    fontFamily: 'Mulish',
    // marginTop: '8%',
    color: 'black'
  },
  topSPaceForHeading_XXXHDPI: {
    marginTop: Platform.OS === 'web' ? 100 : null
  },
  topSPaceForHeading_XXHDPI: {
    marginTop: Platform.OS === 'web' ? 100 : null
  },
  topSPaceForHeading_XHDPI: {
    marginTop: Platform.OS === 'web' ? 20 : null,
    fontSize: 28
  },
  topSPaceForHeading_HDPI: {
    marginTop: 15,
    marginBottom: 15,
    fontSize: 24,
    marginTop: 50
  },
  topSPaceForHeading_LDPI: {
    marginTop: 10,
    marginBottom: 10,
    fontSize: 18,
    marginTop: 20
  },
  topSPaceForHeading_MDPI: {
    marginTop: 10,
    marginBottom: 10,
    fontSize: 18,
    marginTop: 20
  },

  // ..........
  topSPaceForHeadingHome: {
    justifyContent: 'center',
    alignItems: 'center',
    // textAlign: 'center',
    fontSize: 30,
    fontWeight: '900',
    fontFamily: 'Mulish',
    // marginTop: '8%',
    color: 'black',
    backgroundColor: '#101d6c',
    padding: 12,
    borderRadius: 8,
    marginHorizontal: '8%'
  },
  topSPaceForHeadingHome_XXXHDPI: {
    marginTop: Platform.OS === 'web' ? 100 : null
  },
  topSPaceForHeadingHome_XXHDPI: {
    marginTop: Platform.OS === 'web' ? 100 : null
  },
  topSPaceForHeadingHome_XHDPI: {
    marginTop: Platform.OS === 'web' ? 20 : null,
    fontSize: 28
  },
  topSPaceForHeadingHome_HDPI: {
    marginTop: 15,
    marginBottom: 15,
    fontSize: 24,
    marginTop: 50
  },
  topSPaceForHeadingHome_LDPI: {
    marginTop: 10,
    marginBottom: 10,
    fontSize: 18,
    marginTop: 20
  },
  topSPaceForHeadingHome_MDPI: {
    marginTop: 10,
    marginBottom: 10,
    fontSize: 18,
    marginTop: 20
  },

  optionViewLeft: {
    flex: 1,
    height: '100%',
    paddingTop: 10,
    margin: 15
  },

  optionViewRight: {
    flex: 1,
    height: '100%',
    paddingTop: 10,
    margin: 15
  },

  optionViewStyle: {
    flexDirection: 'row',
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 10,
    paddingRight: 10,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.2,
    shadowRadius: 15,
    elevation: 5
  },
  optionViewStyle_XXHDPI: {
    flexDirection: 'row',
    height: 70,
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 10,
    paddingRight: 10,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.2,
    shadowRadius: 15,
    elevation: 5
  },
  optionCardMainVewflex1_XHDPI: {
    marginHorizontal: '5%'
  },
  optionViewStyle_LAPTOP: {
    paddingTop: 30,
    paddingBottom: 30
  },
  optionViewStyle_LDPI: {
    paddingTop: Platform.OS === 'web' ? 15 : 25,
    paddingBottom: Platform.OS === 'web' ? 15 : 25
  },
  optionViewStyle_MDPI: {
    paddingTop: Platform.OS === 'web' ? 15 : 25,
    paddingBottom: Platform.OS === 'web' ? 15 : 25
  },
  optionViewStyle_HDPI: {
    paddingTop: 20,
    paddingBottom: 20
  },
  optionViewText: {
    fontSize: 17,
    color: '#000000',
    textAlign: 'left',
    fontWeight: '500',

    fontFamily: 'Mulish'
  },
  optionViewText_XXXHDPI: {
    fontSize: 18
  },
  optionViewText_XXHDPI: {
    fontSize: 18
  },
  optionViewText_XHDPI: {
    fontSize: 14
  },
  optionViewText_HDPI: {
    fontSize: 16
  },
  optionViewText_MDPI: {
    fontSize: 16
  },
  optionViewText_LDPI: {
    fontSize: 14
  },

  dobView: {
    justifyContent: 'center',
    alignItems: 'center',
    height: 300,
    width: 300,
    borderRadius: 5,
    borderBottomLeftRadius: 2,
    borderBottomRightRadius: 5
  },

  // select card style
  selectDOB: {
    height: 50,
    width: 350,
    backgroundColor: '#101d6c',
    justifyContent: 'center',
    alignItems: 'center',
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5
  },
  selectDOB_MDPI: {
    width: 250
  },
  selectDOB_LDPI: {
    width: 250
  },
  // dob number view
  dobNumberView: {
    height: 250,
    width: 350,
    backgroundColor: 'white',
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
    borderWidth: 1
  },
  dobNumberView_MDPI: {
    height: 200,
    width: 250
  },
  dobNumberView_LDPI: {
    height: 200,
    width: 250
  },
  // dob heading
  dobHeading: {
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingHorizontal: '10%',
    fontSize: 35,
    marginTop: '5%',
    fontFamily: 'Mulish'
  },
  dobHeading_MDPI: {
    fontSize: 30
  },
  dobHeading_LDPI: {
    fontSize: 30
  },
  dobHeading_HDPI: {
    fontSize: 25
  },
  // dob sub heading
  dobSubHeading: {
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingHorizontal: '10%',
    fontSize: 25,
    marginTop: '2%',
    fontFamily: 'Mulish'
  },
  dobSubHeading_MDPI: {
    fontSize: 20
  },
  dobSubHeading_LDPI: {
    fontSize: 20
  },
  dobSubHeading_HDPI: {
    fontSize: 20
  },

  componentHeading: {
    fontSize: 22,
    paddingTop: 5,
    fontFamily: 'Mulish',
    color: 'black'
  },
  componentHeading_MDPI: { fontSize: 14 },
  componentHeading_LDPI: { fontSize: 14 },
  componentHeading_HDPI: { fontSize: 20, paddingTop: 0 },
  componentHeading_XHDPI: { fontSize: 17, paddingTop: 2 },

  componentSubHeading: {
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingHorizontal: '10%',
    fontSize: 20,
    marginVertical: '2%',
    fontFamily: 'Mulish',
    color: 'black',
    zIndex: -9
  },
  componentSubHeading_MDPI: {
    fontSize: 20
  },
  componentSubHeading_LDPI: {
    fontSize: 20
  },
  componentSubHeading_HDPI: {
    fontSize: 20
  },

  componentSubHeading2: {
    paddingTop: 30,
    paddingBottom: 10,
    fontSize: 20,
    fontFamily: 'Mulish',
    color: 'black'
  },
  componentSubHeading2_MDPI: { fontSize: 18 },
  componentSubHeading2_LDPI: { fontSize: 18 },
  componentSubHeading2_HDPI: { fontSize: 18 },
  componentSubHeading2_XHDPI: { fontSize: 18, paddingTop: 20 },
  noHeading: {
    marginTop: Platform.OS == 'web' ? 60 : 90
  },

  // dob calendar view
  dobCalendarView: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '3%',
    marginBottom: '3%'
  },
  dobCalendarView_XXXHDPI: {
    marginBottom: '8%'
  },
  dobCalendarView_HDPI: {
    marginTop: '10%'
  },
  dobCalendarView_LDPI: {
    marginTop: '10%'
  },
  dobCalendarView_MDPI: {
    marginTop: '10%'
  },
  // dob day render
  dobDayRender: {
    height: 50,
    width: '23%',
    margin: '1%',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
    borderColor: '#707070',

    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6,
    backgroundColor: 'white'
  },
  dobDayRender_MDPI: {
    height: 40
  },
  dobDayRender_XXHDPI: {
    height: 40
  },
  dobDayRender_XHDPI: {
    height: 40
  },
  dobDayRender_HDPI: {
    height: 40
  },
  dobDayRender_LDPI: {
    height: 40
  },

  // dob render month
  dobMonthRender: {
    height: 50,
    width: '23%',
    margin: '1%',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
    borderColor: '#707070',

    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6,
    backgroundColor: 'white'
  },
  dobMonthRender_MDPI: {
    height: 40,
    width: '31%',
    margin: '1%'
  },
  dobMonthRender_LDPI: {
    height: 40,
    width: '31%',
    margin: '1%'
  },

  // dob render year
  dobYearRender: {
    height: 80,
    width: '18%',
    margin: '1%',
    borderColor: '#707070',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,

    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6,
    backgroundColor: 'white'
  },
  dobYearRender_MDPI: {
    height: 40,
    width: '31%',
    margin: '1%'
  },
  dobYearRender_LDPI: {
    height: 40,
    width: '31%',
    margin: '1%'
  },

  // redner text style
  calenderText: {
    textAlign: 'center',
    fontSize: 15,
    color: 'black',
    fontFamily: 'Mulish'
  },
  calenderText_HDPI: {
    fontSize: 13
  },
  calenderText_MDPI: {
    fontSize: 12
  },
  calenderText_LDPI: {
    fontSize: 12
  },

  calenderHeading: {
    textAlign: 'center',
    fontSize: 15,
    color: 'white',
    fontFamily: 'Mulish'
  },

  // pan input feild
  backgroundMainview: {
    minHeight: windowHeight,
    //width: windowWidth,
    //position: Platform.OS === 'web' ? 'fixed' : null,
    zIndex: -9
    //backgroundColor: '#f2f2f2'
  },

  backgroundMainviewMobile: {
    //backgroundColor: '#f2f2f2',
    flex: 1
  },
  backgroundImageMainview: {
    width: '100%',
    shadowOpacity: 0.1,
    shadowRadius: 18,
    position: Platform.OS === 'web' ? 'fixed' : null,
    height: 60
  },
  backgroundBoxView: {
    justifyContent: 'center',
    alignItems: 'center',
    height: '60%'
  },
  backgroundImagestyle: {
    resizeMode: 'contain',
    width: 200,
    height: 20,
    borderWidth: 1
  },
  TopnavMainview2: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  TopnavMainview3: {
    flex: 1,
    alignItems: 'flex-start',
    marginLeft: 10
  },
  TopnavMobileMenuicon: {
    width: 30,
    height: 30
  },
  TopnavMobileLogoView: {
    flex: 1,
    alignItems: 'flex-end',
    marginRight: 10
  },
  TopNavDropdownMainViewHeader: {
    //marginLeft: 10,
    paddingTop: 15,
    flex: 1
  },
  TopNavDropdownImgViewHeader: {
    resizeMode: 'contain',
    marginLeft: 10,
    width: 200,
    height: 72
  },
  TopNavDropdownImgViewHeader_HDPI: {
    resizeMode: 'contain',
    width: 48,
    height: 14,
    paddingTop: 10,
    marginTop: '3%'
  },
  TopNavDropdownImgViewHeader_MDPI: {
    resizeMode: 'contain',
    width: 48,
    height: 14,
    paddingTop: 10,
    marginTop: '3%'
  },
  TopNavDropdownImgViewHeader_LDPI: {
    resizeMode: 'contain',
    width: 48,
    height: 14,
    paddingTop: 10,
    marginTop: '3%'
  },
  TopnavMainview: {
    height: 60,
    shadowColor: '#d3d3d3',
    shadowOpacity: 1,
    shadowRadius: 5,
    elevation: 3,
    borderWidth: 0
  },
  TopnavMobileLogostyle: {
    width: 140,
    height: 60
  },
  newTopNavbarupdatescreens: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 5,
    paddingBottom: 5,
    height: 40
  },
  backgroundImagestyle_LDPI: {
    width: 160,
    height: 72
  },
  backgroundImagestyle_MDPI: {
    width: 160,
    height: 72
  },
  backgroundImagestyle_HDPI: {
    width: 160,
    height: 72
  },
  optionViewflexing: {
    flexDirection: 'row'
  },
  optionViewflexing_HDPI: {
    flexDirection: 'column'
  },
  optionViewflexing_LDPI: {
    flexDirection: 'column'
  },
  optionViewflexing_MDPI: {
    flexDirection: 'column'
  },

  textStyle: {
    textAlign: 'center',
    fontSize: 25,
    fontFamily: 'Mulish'
  },
  textStyle_MDPI: {
    fontSize: 20
  },
  textStyle_LDPI: {
    fontSize: 20
  },

  textHeading: {
    textAlign: 'center',
    fontSize: 35,
    fontFamily: 'Mulish'
  },
  textHeading_MDPI: {
    fontSize: 30
  },
  textHeading_LDPI: {
    fontSize: 30
  },
  // ..................................................................................
  backgroundPadding: {
    marginHorizontal: '11.5%',
    // marginTop: '3%',
    zIndex: -9
  },
  backgroundPadding_XXXHDPI: {
    marginHorizontal: '12%'
  },
  backgroundPadding_XXHDPI: {
    marginHorizontal: '12.5%'
  },
  backgroundPadding_XHDPI: {
    marginHorizontal: '8%'
  },
  backgroundPadding_HDPI: {
    marginHorizontal: '12.5%',
    marginTop: Platform.OS === 'web' ? '5%' : '10%'
  },
  backgroundPadding_MDPI: {
    marginHorizontal: '15%',
    marginTop: Platform.OS === 'web' ? '5%' : '5%'
  },
  backgroundPadding_LDPI: {
    marginHorizontal: '16%',
    marginTop: Platform.OS === 'web' ? '5%' : '5%'
  },
  //dob main view -> dobpage

  mainView: {
    flexDirection: 'row',
    // marginBottom: '2%',
    width: 1000
  },
  mainView_XXXHDPI: {
    width: 900
  },
  mainView_XXHDPI: {
    width: 800
  },
  mainView_XHDPI: {
    width: 550
  },
  mainView_HDPI: {
    width: 500
  },
  mainView_LDPI: {
    width: 500
  },
  mainView_MDPI: {
    width: 500
  },
  // dob heading View
  dobHeadingView: {
    flex: 3,
    borderRadius: 5,
    shadowColor: '#000',
    marginHorizontal: '1%',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6,
    backgroundColor: 'white'
  },

  // second main view
  dobSecondView: {
    flexDirection: 'row',
    width: 1000,
    height: 195
  },
  dobSecondView_XXXHDPI: {
    width: 900
  },
  dobSecondView_XXHDPI: {
    width: 800
  },
  dobSecondView_XHDPI: {
    width: 550
  },
  dobSecondView_HDPI: {
    width: 500
  },
  dobSecondView_LDPI: {
    width: 500
  },
  dobSecondView_MDPI: {
    width: 500
  },

  // dob day view
  dobDayView: {
    flexDirection: 'row',
    width: 1000,
    height: 250
  },
  dobDayView_XXXHDPI: {
    width: 900
  },
  dobDayView_XXHDPI: {
    width: 800
  },
  dobDayView_XHDPI: {
    width: 550,
    height: 186
  },
  dobDayView_HDPI: {
    width: 500,
    height: 186
  },
  dobDayView_LDPI: {
    width: 500,
    height: 186
  },
  dobDayView_MDPI: {
    width: 500,
    height: 186
  },
  // dob arrow view
  dobArrowMainView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },

  arrowRight: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'flex-end'
  },

  arrowLeft: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'flex-start'
  },

  // dob arrow view padding
  dobArrowPadding: {
    paddingVertical: '15%',
    paddingHorizontal: '25%',
    backgroundColor: '#e2e2e2',
    borderRadius: 10
  },

  dobDayArrowPadding: {
    padding: '5%',
    backgroundColor: '#e2e2e2',
    borderRadius: 10
  },

  dobDayArrow: {
    paddingVertical: '10%',
    paddingHorizontal: '20%',
    backgroundColor: '#e2e2e2',
    borderRadius: 10
  },
  //panNumberTop
  panNumberTop: {
    marginTop: '0%'
  },
  panNumberTop: {
    marginTop: '15%'
  },
  optionCardSecondaryStyle: {
    padding: Platform.OS === 'web' ? 20 : '10%',
    flex: 1
  },
  optionCardSecondaryStyleforAccount: {
    padding: Platform.OS === 'web' ? 20 : '10%',
    width: widthInPercentage(50),
    marginHorizontal: widthInPercentage(25)
  },
  optionCardSecondaryStyle_MDPI: {
    padding: Platform.OS === 'web' ? 10 : '10%',
    flex: 1
  },
  optionCardSecondaryStyle_LDPI: {
    padding: Platform.OS === 'web' ? 10 : '10%',
    flex: 1
  },
  optionCardSecondaryStyleforAccount: {
    padding: Platform.OS === 'web' ? 20 : '10%',
    width: widthInPercentage(50),
    marginHorizontal: widthInPercentage(25)
  },
  optionCardSecondaryStyleforAccount_MDPI: {
    padding: Platform.OS === 'web' ? 10 : '10%',
    width: widthInPercentage(100),
    marginHorizontal: widthInPercentage(0)
  },
  optionCardSecondaryStyleforAccount_LDPI: {
    padding: Platform.OS === 'web' ? 10 : '10%',
    width: widthInPercentage(100),
    marginHorizontal: widthInPercentage(0)
  },
  optionCardMainVewflex1: {
    flexDirection: 'column',
    marginHorizontal: '10%',
    zIndex: -9
  },
  optionCardMainVewflex1_LAPTOP: {
    paddingTop: 20
  },
  optionCardMainVewflex2: {
    flexDirection: 'row',
    marginBottom: '2%'
  },
  optionCardMainVewflex2_LDPI: {
    flexDirection: 'column'
  },
  optionCardMainVewflex2_MDPI: {
    flexDirection: 'column'
  },
  optionCardMainVewflex2_HDPI: {
    flexDirection: 'column'
  },

  viewBackground: {
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  },
  nav: {
    position: Platform.OS === 'web' ? 'fixed' : null,
    width: '100%',
    backgroundColor: '#fff',
    zIndex: 99999
  },
  Updatebutton: {
    backgroundColor: '#101d6c',
    // backgroundImage:
    //   Platform.OS === "web" ? "linear-gradient(#00008B,#101d6c)" : null,
    marginBottom: 10,
    borderRadius: 12,
    textAlign: 'center',
    width: 120,
    paddingVertical: '1%',
    color: 'black',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6
  },
  loadingImagestyle: {
    width: 80,
    height: 80
  },
  submitBtn: {
    width: '50%',
    height: 50,
    justifyContent: 'center',
    // shadowOpacity: 2,
    // shadowRadius: 3,
    borderRadius: 1,
    backgroundColor: '#2a5298',
    padding: 16,
    borderRadius: 5,
    marginTop: 25
    //paddingHorizontal: 10
  },
  submitBtn_MDPI: {
    marginTop: 25
  },
  submitBtn_LDPI: {
    marginTop: 15
  },
  submitBtn_HDPI: {
    marginTop: 15
  },
  submitBtn_XHDPI: {
    marginTop: 20
  },
  submitBtn_XXHDPI: {
    marginTop: 30
  },
  newserviceText: {
    textAlign: 'center',
    justifyContent: 'center',
    fontFamily: 'Mulish',
    fontWeight: 'bold',
    fontSize: 14,
    color: '#fff'
  },
  homeButtonStyle: {
    textAlign: 'center',
    justifyContent: 'center',
    fontFamily: 'Mulish',
    fontWeight: 'bold',
    fontSize: 14,
    color: '#fff'
  },
  homeButtonStyle_MDPI: {
    fontSize: 10
  },
  homeButtonStyle_LDPI: {
    fontSize: 10
  },
  newserviceText_MDPI: {
    textAlign: 'center',
    justifyContent: 'center',
    fontFamily: 'Mulish',
    fontWeight: 'bold',
    fontSize: 8,
    color: '#fff'
  },
  Homebutton: {
    width: widthInPercentage(12),
    alignItems: 'center'
  },
  Homebutton_MDPI: {
    width: widthInPercentage(25),
    alignItems: 'center'
  },
  Homebutton_LDPI: {
    width: widthInPercentage(40),
    alignItems: 'center'
  },
  Homebutton_HDPI: {
    width: widthInPercentage(40),
    alignItems: 'center'
  },
  Homebutton_XHDPI: {
    width: widthInPercentage(25),
    alignItems: 'center'
  },
  Homebutton_XXHDPI: {
    width: widthInPercentage(25),
    alignItems: 'center'
  },
  ModalStyle: { width: widthInPercentage(50), marginHorizontal: widthInPercentage(22) },
  ModalStyle_LAPTOP: { width: widthInPercentage(50), marginHorizontal: widthInPercentage(22) },
  ModalATMStyle: { width: widthInPercentage(35), marginHorizontal: widthInPercentage(30) },
  ModalStyle_XHDPI: { width: widthInPercentage(70), marginHorizontal: widthInPercentage(15) },
  ModalStyle_XXHDPI: { width: widthInPercentage(47), marginHorizontal: widthInPercentage(22) },
  ModalStyle_XXXHDPI: { width: widthInPercentage(45), marginHorizontal: widthInPercentage(20) },
  ModalStyle_LDPI: { width: widthInPercentage(94), marginHorizontal: widthInPercentage(2) },
  ModalStyle_MDPI: { width: widthInPercentage(80), marginHorizontal: widthInPercentage(10) },

  TopnavMobileIPLOCATIONdettopnavmobHeader: {
    padding: 15
  },
  TopnavMobileIPLOCATIONdettopnavmobHeader_MDPI: {
    padding: 10,
  },
  TopnavMobileIPLOCATIONdettopnavmobHeader_LDPI: {
    padding: 10,
    width: '100%'
  },

  TopnavMobileIPTextHeader: {
    fontSize: 14,
    fontFamily: 'Mulish',
    left: '2%'
  },
  TopnavMobileIPTextHeader_XHDPI: {
    fontSize: 12,
    fontFamily: 'Mulish'
  },
  newTopNavImage2Mainview: {
    flex: 1,
    //alignItems: 'flex-end',
    alignItems: 'flex-start',
    // padding: 10,
    // paddingLeft: 20
  },
  newTopNavImage2MainviewLocation: {
    flex: 1,
    alignItems: 'flex-start',
    padding: 10,
    paddingLeft: 20
  },
  newTopNavImage2Mainview1: {
    flex: 0.5,
    //alignItems: 'flex-end',
    alignItems: 'flex-start',
    padding: 10,
    paddingLeft: 20
  },
  newTopNavImage2Mainview_XHDPI: {
    flex: 1,
    alignItems: 'flex-start',
    padding: 10
  },
  TopnavMobileIPText: {
    fontSize: 14,
    fontFamily: 'Mulish',
    left: '2%'
  },
  TopnavMobileIPText_XHDPI: {
    fontSize: 12,
    fontFamily: 'Mulish'
  },
  messageContainer:{
      flex: 1,
      alignItems: "center",
      paddingTop: "10%",
      backgroundColor: "#fcebd6"
  },
  messageHeading:{
    fontSize: 32, 
    fontWeight: "bold", 
    textAlign: "center" 
  },
  messageSubheading:{
    fontSize: 22, 
    textAlign: "center"
  },
  containerSlider:{
    display:'flex',
    flexDirection:'column',
    width:'100%',
    height:250,
    overflowY:'scroll'
  },
  containerSlider_MDPI: {
    flexDirection:'column',
    height:'auto',
  },
  containerSlider_LDPI: {
    flexDirection:'column',
    height:'auto',
  },
  containerSlider_HDPI: {
   flexDirection:'column',
   height:'auto',
  },
});
